import React from 'react'
import { FormField } from 'uiwidgets/FormField';

const CountrySelect = (props) => {
    return (
        <FormField name={props.name} label="Country" type="select"
            placeholder="Country" onChange={props.onChange} onBlur={props.onBlur}
            valstate={props.valstate} valMsg={props.valMsg}
            readOnly={props.readOnly} value={props.value||"CA"}>
            <option value="CA">Canada</option>
            <option value="US">USA</option>
        </FormField>
    )
}
export default CountrySelect